import React from 'react';
import Button from '../../molecules/button';
import { useIntl } from '../../../common/config/i18n';
import history from '../../../app-router/history';

interface Props {
  message: string;
  onClick?: () => void;
}
const ConfirmForm: React.FC<Props> = ({ message, onClick }: Props) => {
  const { t } = useIntl();
  return (
    <>
      <p>{message}</p>
      <Button
        onClick={() => {
          if (onClick) {
            onClick();
          }
          history.push('/login');
        }}
        height="50px"
        width="100%"
        borderRadius="20px"
      >
        {t('form', 'FORM_CONNECT_LINK')}
      </Button>
    </>
  );
};

export default ConfirmForm;
